'use strict';

const tokenOptions = {
    algorithm: "HS256", 
    expiresIn: "365d"
}

module.exports = tokenOptions 